import { formatNumber } from './number';
import { formatString } from './string';
export const formatMetricCubicCentimetres = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    suffix: ' cc',
    fallback,
});
export const formatMetricGramsPerKilometres = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    suffix: ' g/km',
    fallback,
});
export const formatMetricHours = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 1,
    suffix: ' uur',
    fallback,
});
/**
 * Format the supplied value as hour:minute uur value or - if the supplied value is not in the format of
 * hour.minute or hour:minute
 *
 * @param value the hour.time value to format
 * @returns the supplied value as 'hour:minute uur' or the fallback value (null by default)
 *
 * @example
 *
 * formatMetricHoursMinutes('10.45'); // 10:45 uur
 */
export const formatMetricHoursMinutes = (value, { fallback = null } = { fallback: null }) => {
    if (value === undefined)
        return fallback;
    const hourMinuteRegEx = /^(\d+)[.:]([0-5][0-9])$/;
    const match = hourMinuteRegEx.exec(value);
    if ((match === null || match === void 0 ? void 0 : match.length) === 3) {
        return formatString(`${match[1]}:${match[2]}`, {
            suffix: ' uur',
            fallback: null,
        });
    }
    return fallback;
};
export const formatMetricKilograms = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 0,
    suffix: ' kg',
    fallback,
});
export const formatMetricKilometres = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 0,
    suffix: ' km',
    fallback,
});
export const formatMetricKilometresPerHour = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 0,
    suffix: ' km/h',
    fallback,
});
export const formatMetricKilowattDirectCurrent = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 0,
    suffix: ' kW DC',
    fallback,
});
export const formatMetricKilowatt = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 1,
    suffix: ' kW',
    hideEmptyDecimals: true,
    fallback,
});
export const formatMetricKilowattHour = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 1,
    suffix: ' kWh',
    fallback,
});
export const formatMetricLitres = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    suffix: ' l',
    fallback,
});
export const formatMetricMetres = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 1,
    suffix: ' m',
    fallback,
});
export const formatMetricMiliMetres = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    suffix: ' mm',
    fallback,
});
export const formatMetricNewtonmetre = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 0,
    suffix: ' Nm',
    fallback,
});
export const formatMetricSeconds = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 1,
    suffix: ' s',
    fallback,
});
/**
 * Format the supplied value as value year value or the given fallback value
 *
 * @param value the value to format
 * @param {string} fallback - The fallback value, null by default.
 * @param {string} employee.ignoreZero - true if a value of 0 needs to be ignored and results in the fallback value
 * @returns the supplied value as 'value jaar' or the fallback value
 *
 * @example
 *
 * formatMetricYears(10); // 10 jaar
 * formatMetricYears(0); // 0 jaar
 * formatMetricYears(0, true); // -
 * formatMetricYears(0, false); // 0 jaar
 */
export const formatMetricYears = (value, { fallback = null, ignoreZero } = { ignoreZero: true, fallback: null }) => formatNumber(value, {
    suffix: ' jaar',
    ignoreZero,
    fallback,
});
/**
 * Format distance as kilometers or meters, depending on distance.
 *
 * @param distance in meters
 * @returns distance as kilometers or meters
 */
export const formatMetricKiloMetresOrMetres = (distance, { fallback = null } = { fallback: null }) => {
    if (!distance || Number.isNaN(distance)) {
        return fallback;
    }
    return distance >= 1000 && distance > 0
        ? `${(distance / 1000).toFixed(1).toString()} km`
        : `${distance.toFixed(0)} m`;
};
